import { LoginService } from './../../login/login.service';
import {
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  HostListener,
  AfterViewInit,
  ViewChild,
  inject,
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { LoadingService } from '../../../auxiliares/servicios/loading.service';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { ThemesService } from '../../../auxiliares/servicios/themes.service';
import { Subscription, take } from 'rxjs';
import { ICliente } from 'modelos/src';
import { Router } from '@angular/router';
import { ESTADO_RAIZ } from '../../../auxiliares/servicios/origen.service';
import { PushNotificationsService } from '../../../auxiliares/servicios/push-notifications.service';
import { ListadoEventosGenericosVivoService } from '../../../auxiliares/servicios/listado-eventos-genericos-vivo';
import { MaterialesPendientesService } from '../../../auxiliares/servicios/materiales-pendientes.service';
import { ServiciosTecnicosPendientesService } from '../../../auxiliares/servicios/servicios-tecnicos-pendientes.service';
import { MatDialog } from '@angular/material/dialog';
import { AppSettingsComponent } from '../app-settings/app-settings.component';
import { Lista2Service } from '../../../auxiliares/servicios/lista2.service';
import { TratamientoMinimizadoService } from '../../entidades/eventos-genericos/tratar-evento-generico/tratamiento-minimizado.service';
import { ListadoAlertasSeguridadVivoService } from '../../../auxiliares/servicios/listado-alertas-seguridad-vivo';
import { InactividadUsuarioService } from '../../../auxiliares/servicios/inactividad-usuario.service';
import { ActividadUsuarioService } from '../../../auxiliares/servicios/actividad-usuario.service';
import { TemaRuntimeService } from '../../../auxiliares/servicios/tema-runtime.service';
import { GastosService } from '../../../auxiliares/servicios/http/gastos.service';
import { GASTOS_HABILITADO } from '../../entidades/gastos/gastos.guard';
import {
  PERMISOS_VER_FACTURACION,
  SOLAPAS_FACTURACION,
} from '../../entidades/facturacion-v2/facturacion.constantes';
import { ClienteSelectorCacheService } from '../../../componentes/selectores/cliente-selector/cliente-selector-cache.service';
import { Observable } from 'rxjs';
import { ITema } from 'modelos/src';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
  standalone: false,
})
export class NavigationComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  loading = inject(LoadingService);
  helper = inject(HelperService);
  temas = inject(ThemesService);
  private lista2 = inject(Lista2Service);
  private clienteSelectorCache = inject(ClienteSelectorCacheService);
  private router = inject(Router);
  /** Entrar por el menú arranca las migas de cero. */
  public readonly estadoRaiz = ESTADO_RAIZ;
  pushNotificationsService = inject(PushNotificationsService);
  listadoEventosGenericosVivoService = inject(
    ListadoEventosGenericosVivoService,
  );
  materialesPendientesService = inject(MaterialesPendientesService);
  serviciosTecnicosPendientesService = inject(
    ServiciosTecnicosPendientesService,
  );

  // Total del panel Servicio Técnico: ST pendientes + materiales pendientes.
  public get pendientesServicioTecnico(): number {
    return (
      this.serviciosTecnicosPendientesService.totalCount +
      this.materialesPendientesService.totalCount
    );
  }
  loginService = inject(LoginService);
  private dialog = inject(MatDialog);
  tratamientoMinimizado = inject(TratamientoMinimizadoService);
  listadoAlertasSeguridadVivoService = inject(
    ListadoAlertasSeguridadVivoService,
  );
  private inactividadUsuarioService = inject(InactividadUsuarioService);
  private actividadUsuarioService = inject(ActividadUsuarioService);
  private temaRuntime = inject(TemaRuntimeService);
  private gastosService = inject(GastosService);

  private cliente$?: Subscription;
  public usuario = LoginService.getUsuario();
  public clientePropio?: ICliente;
  public permiso = LoginService.getPermisoActual();
  public modulosHabilitados = this.helper.modulosHabilitados();
  /** Si el cliente puede ver la vista Gastos (nivel 1 o raíz independiente). */
  public verGastos = false;

  /**
   * Facturación es un módulo más de la lista, pero no depende de la config del
   * cliente: aparece con cualquier permiso `Facturación - Ver …`, así lo ve
   * también quien sólo paga.
   */
  public verFacturacion(): boolean {
    return this.helper.tienePermiso(...PERMISOS_VER_FACTURACION);
  }

  /** Secciones del módulo Facturación que el permiso deja ver. */
  public get seccionesFacturacion() {
    return SOLAPAS_FACTURACION.filter((s) =>
      this.helper.tienePermiso(...s.permisos),
    );
  }

  /**
   * El badge de ST solo corre si el permiso activo tiene el módulo. Antes se
   * arrancaba para todo usuario logueado, y eso dejaba a CUALQUIERA suscripto
   * por WS a `eventogenerico` (un room de decenas de mensajes por segundo)
   * más su polling, para un badge que nunca iba a ver.
   */
  private actualizarBadgeServicioTecnico(): void {
    if (this.helper.tieneModulo('Servicio Técnico')) {
      this.serviciosTecnicosPendientesService.reiniciar();
    } else {
      this.serviciosTecnicosPendientesService.detener();
    }
  }

  public onPermisoChanged() {
    // El listado de clientes depende del permiso/cliente actual: se descarta el
    // caché viejo y se vuelve a precargar de fondo.
    this.clienteSelectorCache.invalidate();
    this.clienteSelectorCache.preload();

    this.modulosHabilitados = this.helper.modulosHabilitados();
    this.loadModuleConfig();
    this.listadoEventosGenericosVivoService.reiniciar();
    this.listadoAlertasSeguridadVivoService.reiniciar();
    this.materialesPendientesService.reiniciar();
    this.actualizarBadgeServicioTecnico();
    this.inactividadUsuarioService.iniciarServicio();
    this.actividadUsuarioService.iniciarServicio();
    this.actualizarVerGastos();
  }

  public editMode = false;
  public showAlarmaConfig = false;
  public showCamaraConfig = false;
  public showSirenaConfig = false;
  public showLuminariaConfig = false;
  public showVehiculoConfig = false;
  public showActivoConfig = false;
  public showColectivoConfig = false;
  public modulosOrdenados: { key: string; visible: boolean }[] = [];

  private readonly ALL_MODULES = [
    { key: 'alarmas', modulo: 'Alarmas' },
    { key: 'camaras', modulo: 'Cámaras' },
    { key: 'emergencias-medicas', modulo: 'Emergencias Médicas' },
    { key: 'activos', modulo: 'Activos' },
    { key: 'logs', modulo: 'Logs' },
    { key: 'luminarias', modulo: 'Luminarias' },
    { key: 'sirenas', modulo: 'Sirenas' },
    { key: 'colectivos', modulo: 'Colectivos' },
    { key: 'vehiculos', modulo: 'Vehículos' },
  ] as const;

  public drawerWidth = parseInt(
    localStorage.getItem('drawerWidth') || '300',
    10,
  );
  private resizing = false;
  private startX = 0;
  private startWidth = 0;

  @ViewChild('drawerContainer') drawerContainer!: MatSidenavContainer;
  @ViewChild('drawerContainer', { read: ElementRef })
  drawerContainerEl?: ElementRef<HTMLElement>;
  @ViewChild('drawer') drawer!: MatSidenav;
  @ViewChild('drawer', { read: ElementRef })
  drawerEl?: ElementRef<HTMLElement>;

  private maxDrawerWidth(): number {
    return Math.min(600, window.innerWidth - 100);
  }

  public notificacionesActivas?: boolean;
  public expandedPanel?: number;
  public tema$: Observable<ITema | null>;

  constructor() {
    this.listadoEventosGenericosVivoService.iniciarServicio();
    this.listadoAlertasSeguridadVivoService.iniciarServicio();
    this.materialesPendientesService.iniciarServicio();
    this.actualizarBadgeServicioTecnico();
    this.inactividadUsuarioService.iniciarServicio();
    this.actividadUsuarioService.iniciarServicio();
    this.tema$ = this.temaRuntime.tema$;
  }

  public editarClientePropio() {
    window.location.href = `/main/clientes/editar/${this.clientePropio?._id}`;
  }

  public openAppSettings() {
    // Ancho de un formulario chico; se cierra también con clic afuera
    this.dialog.open(AppSettingsComponent, {
      width: '480px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      autoFocus: false,
    });
  }

  // Método para cerrar el sidenav (solo en mobile)
  public toggleSidenav() {
    if (!this.drawer) return;
    this.helper.isHandset$.pipe(take(1)).subscribe((isHandset) => {
      if (isHandset) {
        this.drawer.close();
      }
    });
  }

  private async clienteUpdate() {
    this.cliente$?.unsubscribe();
    this.cliente$ = this.lista2.clientePropio().subscribe((data) => {
      this.clientePropio = data;
      if (data.config) {
        this.temas.setTema(data.config);
      }
    });
  }

  private openPanelInicial() {
    const ruta = this.router.url;
    if (
      ruta.includes('/main/administracion') ||
      ruta.includes('/main/integraciones')
    ) {
      this.expandedPanel = 0;
    } else if (ruta.includes('/main/alarmas')) {
      this.expandedPanel = 1;
    } else if (ruta.includes('/main/camaras')) {
      this.expandedPanel = 2;
    } else if (ruta.includes('/main/configuracion')) {
      this.expandedPanel = 3;
    } else if (ruta.includes('/main/emergencias')) {
      this.expandedPanel = 5;
    } else if (ruta.includes('/main/activos')) {
      this.expandedPanel = 6;
    } else if (ruta.includes('/main/logs')) {
      this.expandedPanel = 7;
    } else if (ruta.includes('/main/luminarias')) {
      this.expandedPanel = 8;
    } else if (
      ruta.includes('/main/servicio-tecnico') ||
      // Listado de vehículos del menú de Servicio Técnico
      ruta.includes('/main/vehiculos/servicio-tecnico')
    ) {
      this.expandedPanel = 9;
    } else if (ruta.includes('/main/sirenas')) {
      this.expandedPanel = 10;
    } else if (ruta.includes('/main/colectivos')) {
      this.expandedPanel = 11;
    } else if (ruta.includes('/main/vehiculos')) {
      this.expandedPanel = 12;
    }
  }

  public panelClosed(panel: number) {
    // Solo limpia expandedPanel si el panel que se cierra era el activo.
    // Esto evita que el cierre automático dentro del mismo accordion
    // sobreescriba el valor seteado por el (opened) del nuevo panel.
    if (this.expandedPanel === panel) {
      this.expandedPanel = undefined;
    }
  }

  get hasHiddenModules(): boolean {
    return this.modulosOrdenados.some((m) => !m.visible);
  }

  public toggleEditMode() {
    this.editMode = !this.editMode;
  }

  public loadModuleConfig() {
    const savedOrder: string[] =
      JSON.parse(localStorage.getItem('navModuleOrder') || 'null') ??
      this.ALL_MODULES.map((m) => m.key);
    const savedHidden: string[] = JSON.parse(
      localStorage.getItem('navModuleHidden') || '[]',
    );

    const disponibles: string[] = this.ALL_MODULES.filter((m) =>
      this.helper.tieneModulo(m.modulo),
    ).map((m) => m.key);
    if (this.verFacturacion()) disponibles.push('facturacion');

    const ordered = savedOrder
      .filter((key) => disponibles.includes(key))
      .map((key) => ({ key, visible: !savedHidden.includes(key) }));

    // Agregar módulos nuevos que no estén en el orden guardado
    for (const key of disponibles) {
      if (!ordered.find((m) => m.key === key)) {
        ordered.push({ key, visible: true });
      }
    }

    this.modulosOrdenados = ordered;
  }

  public saveModuleConfig() {
    localStorage.setItem(
      'navModuleOrder',
      JSON.stringify(this.modulosOrdenados.map((m) => m.key)),
    );
    localStorage.setItem(
      'navModuleHidden',
      JSON.stringify(
        this.modulosOrdenados.filter((m) => !m.visible).map((m) => m.key),
      ),
    );
  }

  public dropModulo(event: CdkDragDrop<{ key: string; visible: boolean }[]>) {
    moveItemInArray(
      this.modulosOrdenados,
      event.previousIndex,
      event.currentIndex,
    );
    this.saveModuleConfig();
  }

  public toggleVisibility(key: string) {
    const modulo = this.modulosOrdenados.find((m) => m.key === key);
    if (modulo) {
      modulo.visible = !modulo.visible;
      this.saveModuleConfig();
    }
  }

  public scrollPanelIntoView(panelId: string) {
    setTimeout(() => {
      document
        .getElementById(panelId)
        ?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 0);
  }

  public async activarNotificaciones() {
    const estado = await this.pushNotificationsService.requestPermission();
    if (estado === 'granted') {
      await this.pushNotificationsService.iniciarPermisos();
      this.notificacionesActivas = estado === 'granted';
    }
  }

  /**
   * El contenido del drawer tiene una transición de `margin` (de Material).
   * Durante el arrastre hay que apagarla o cada mousemove reinicia la
   * animación y el layout parece congelado hasta que se suelta el clic.
   * Se togglea por DOM (y no por binding) para que valga desde el primer
   * mousemove, sin depender de un ciclo de detección de cambios.
   */
  private marcarResizing(activo: boolean): void {
    for (const ref of [this.drawerEl, this.drawerContainerEl]) {
      ref?.nativeElement.classList.toggle('resizing', activo);
    }
  }

  startResize(event: MouseEvent) {
    this.resizing = true;
    this.startX = event.clientX;
    this.startWidth = this.drawerWidth;
    this.marcarResizing(true);
    event.preventDefault();
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.resizing) {
      return;
    }
    const newWidth = this.startWidth + event.clientX - this.startX;
    this.drawerWidth = Math.min(Math.max(newWidth, 300), this.maxDrawerWidth());
    // Escribir el ancho a mano además del binding: el repintado acompaña al
    // mouse aunque la detección de cambios llegue un tick más tarde.
    if (this.drawerEl) {
      const style = this.drawerEl.nativeElement.style;
      style.width = `${this.drawerWidth}px`;
      style.minWidth = `${this.drawerWidth}px`;
    }
    this.drawerContainer.updateContentMargins();
  }

  @HostListener('window:mouseup')
  stopResize() {
    if (this.resizing) {
      this.resizing = false;
      this.marcarResizing(false);
      localStorage.setItem('drawerWidth', this.drawerWidth.toString());
      this.drawerContainer.updateContentMargins();
      this.avisarCambioDeAncho();
    }
  }

  /**
   * Avisa que cambió el ancho del contenido al abrir, cerrar o redimensionar
   * el menú. Mapbox sólo escucha el resize de la ventana: sin esto el mapa
   * queda con el ancho viejo y una franja vacía al costado.
   */
  public avisarCambioDeAncho(): void {
    window.dispatchEvent(new Event('resize'));
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (this.drawerWidth > this.maxDrawerWidth()) {
      this.drawerWidth = this.maxDrawerWidth();
    }
    this.drawerContainer.updateContentMargins();
  }

  ngOnDestroy() {
    // Salir del shell (ej: flecha atrás del navegador hacia el login) no
    // limpia la sesión de sessionStorage: desarmar el control de inactividad
    // acá para que el cartel no siga corriendo fuera de la app.
    this.inactividadUsuarioService.detener();
    this.actividadUsuarioService.detener();
    this.cliente$?.unsubscribe();
  }

  async ngOnInit() {
    // Precarga de fondo del listado de clientes: no se espera, sólo calienta el
    // caché para que el primer selector que se abra no tenga que pedirlo.
    this.clienteSelectorCache.preload();

    const [estado] = await Promise.all([
      this.pushNotificationsService.estadoPermisos(),
      this.clienteUpdate(),
    ]);
    this.notificacionesActivas = estado === 'granted';

    this.openPanelInicial();
    this.loadModuleConfig();
    this.actualizarVerGastos();
  }

  /**
   * Decide si mostrar el ítem Gastos: (nivel 1 o raíz independiente) y
   * usuario con rol Administrador (info de costos).
   */
  private async actualizarVerGastos(): Promise<void> {
    // Vista deshabilitada globalmente (ver GASTOS_HABILITADO).
    if (!GASTOS_HABILITADO) {
      this.verGastos = false;
      return;
    }
    if (!this.helper.esRolAdministrador()) {
      this.verGastos = false;
      return;
    }
    if (this.helper.esNivel1()) {
      this.verGastos = true;
      return;
    }
    if (this.helper.esClienteNivel0()) {
      this.verGastos = false;
      return;
    }
    try {
      const { facturable } = await this.gastosService.esFacturable();
      this.verGastos = facturable;
    } catch {
      this.verGastos = false;
    }
  }

  ngAfterViewInit() {
    this.drawerWidth = Math.min(this.drawerWidth, this.maxDrawerWidth());
    this.drawerContainer.updateContentMargins();
  }

  async ngOnChanges() {
    await this.clienteUpdate();
  }
}
